import mapboxgl from 'mapbox-gl'

export default {
    props: {
        zoomLevel: {
            type: Number,
            default: 4
        },
        coordinates: {
            type: Array,
            default: function () {
                return [139, 35]
            }
        }
    },
    data() {
        return {
            currentZoomLevel: this.zoomLevel
        }
    },
    methods: {
        handleCompass() {
            const navigationControl = new mapboxgl.NavigationControl({
                showCompass: true,
                showZoom: false
            });
            this.mySmartMap.addControl(navigationControl, 'bottom-right');
        },
        changeStartingPosition() {
            this.mySmartMap.flyTo({
                center: this.coordinates,
                speed: 1.8
            })
        },
        changeZoom(val) {
            this.mySmartMap.flyTo({
                zoom: val,
                speed: 1.8
            })
        }
    },
    watch: {
        zoomLevel() {
            this.changeZoom(this.zoomLevel)
        },
        currentZoomLevel() {
            this.changeZoom(this.currentZoomLevel)
        },
    }
}